import React, { useState, useEffect, useMemo } from "react";
import trophy from "../../assets/trophy.jpg";
import DaterangePicker from "../../common/Daterangepicker";
import Citiescommondropdown from "../../common/Citiescommondropdown";
import { useSelector } from "react-redux";
import { Search } from "lucide-react";
import formatDateForApi from "../../common/formatDateForApi";
import toast from "react-hot-toast";
import Person3Icon from "@mui/icons-material/Person3";
import DashboardSkeleton from "../../common/DashboardSkeleton";

const Kpidashboard = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [cityFilter, setCityFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [kpiData, setKpiData] = useState([]);
  let token = localStorage.getItem("token");
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  const cityOptions = useMemo(() => {
    if (!cities) return [];
    return Object.entries(cities).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  }, [cities]);

  useEffect(() => {
    getKpiAPIData();
  }, []);

  const getKpiAPIData = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    const formattedStartDate = formatDateForApi(
      selectionRange?.startDate,
      "start",
    );
    const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    let query = "";
    if (cityFilter && cityFilter !== "All Cities") {
      query += `&cityId=${cityFilter}`;
    }
    const url = `${apiUrl}/api/dashboardreports/fleet-executive-kpi-dashboard?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setKpiData(data?.dataValues);
        setCurrentPage(1);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      setLoading(false);
      console.error("Error fetching Hub Names:", error);
    }
  };

  return (
    <>
      {loading ? (
        <>
          <DashboardSkeleton />
        </>
      ) : (
        <>
          <div className="w-full p-4 my-4">
            <div className="flex justify-between items-center gap-3 px-3 my-8">
              <h1 className="text-gray-900 text-2xl font-bold tracking-tight">
                KPI Dashboard
              </h1>
              <div className="flex gap-4 justify-end">
                <DaterangePicker
                  selectionRange={selectionRange}
                  setSelectionRange={setSelectionRange}
                  style={-10}
                />

                <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
                  <div className="min-w-[180px] px-3 py-2 bg-white rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex justify-start items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="flex-shrink-0 w-4 h-4"
                    >
                      <path
                        d="M8.4005 14.5327C9.6405 13.462 13.3332 9.99534 13.3332 6.66668C13.3332 5.25219 12.7713 3.89563 11.7711 2.89544C10.7709 1.89525 9.41433 1.33334 7.99984 1.33334C6.58535 1.33334 5.2288 1.89525 4.2286 2.89544C3.22841 3.89563 2.6665 5.25219 2.6665 6.66668C2.6665 9.99534 6.35917 13.462 7.59917 14.5327C7.71469 14.6195 7.85531 14.6665 7.99984 14.6665C8.14437 14.6665 8.28499 14.6195 8.4005 14.5327Z"
                        stroke="#99A1AF"
                        strokeWidth="1.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 8.66666C9.10457 8.66666 10 7.77123 10 6.66666C10 5.56209 9.10457 4.66666 8 4.66666C6.89543 4.66666 6 5.56209 6 6.66666C6 7.77123 6.89543 8.66666 8 8.66666Z"
                        stroke="#99A1AF"
                        strokeWidth="1.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <Citiescommondropdown
                      value={cityFilter}
                      onChange={setCityFilter}
                      options={[
                        { value: null, label: "All Cities" },
                        ...cityOptions,
                      ]}
                      placeholder="City"
                      className="flex-1 min-w-[80px]"
                      showSearch={true}
                    />
                  </div>
                </div>

                <button
                  onClick={() => {
                    getKpiAPIData();
                  }}
                  className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg"
                >
                  <Search size={18} />
                  Search
                </button>
              </div>
            </div>
            {/* <div className="self-stretch w-full h-28 p-5 bg-white rounded-xl shadow-[0px_6px_18px_-6px_rgba(15,23,42,0.04)] outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex justify-start items-center gap-5">
        <div className="size-11 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-amber-200 inline-flex flex-col justify-center items-center">
          <div className="size-5 relative overflow-hidden">
            <img src={trophy} alt="Trophy" />
          </div>
        </div>
        <div className="size-14 bg-green-900 rounded-3xl inline-flex flex-col justify-center items-center">
          <div className="justify-start text-white text-lg font-extrabold font-['Inter']">
            MU
          </div>
        </div>
        <div className="flex-1 inline-flex flex-col justify-start items-start gap-2">
          <div className="self-stretch inline-flex justify-start items-center gap-2.5">
            <div className="justify-start text-slate-800 text-base font-extrabold font-['Inter']">
              MUNNER
            </div>
            <div className="size- px-2.5 py-1 bg-amber-100 rounded-[999px] outline outline-1 outline-offset-[-1px] outline-amber-200 flex justify-start items-center">
              <div className="justify-start text-amber-800 text-xs font-extrabold font-['Inter'] uppercase">
                TOPPER
              </div>
            </div>
          </div>
          <div className="self-stretch justify-start text-slate-500 text-xs font-medium font-['Inter'] leading-4">
            Score: 7.04/10 - April 2025 | G:79 App:37 Video:4
          </div>
        </div>
        <div className="w-80 flex justify-between items-center">
          <div className="size- inline-flex flex-col justify-start items-center gap-1">
            <div className="justify-start text-slate-800 text-lg font-extrabold font-['Inter']">
              18
            </div>
            <div className="justify-start text-slate-500 text-xs font-semibold font-['Inter'] uppercase">
              HD DEL
            </div>
          </div>
          <div className="size- inline-flex flex-col justify-start items-center gap-1">
            <div className="justify-start text-slate-800 text-lg font-extrabold font-['Inter']">
              43
            </div>
            <div className="justify-start text-slate-500 text-xs font-semibold font-['Inter'] uppercase">
              HUB DEL
            </div>
          </div>
          <div className="size- inline-flex flex-col justify-start items-center gap-1">
            <div className="justify-start text-slate-800 text-lg font-extrabold font-['Inter']">
              13
            </div>
            <div className="justify-start text-slate-500 text-xs font-semibold font-['Inter'] uppercase">
              HD PU
            </div>
          </div>
          <div className="size- inline-flex flex-col justify-start items-center gap-1">
            <div className="justify-start text-slate-800 text-lg font-extrabold font-['Inter']">
              30
            </div>
            <div className="justify-start text-slate-500 text-xs font-semibold font-['Inter'] uppercase">
              HUB PU
            </div>
          </div>
        </div>
      </div> */}

            <div className="self-stretch mt-4 w-full inline-flex justify-start items-start gap-4">
              <div className="flex-1 self-stretch p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                    Total Deliveries
                  </div>
                </div>
                <div className="justify-start text-slate-800 text-3xl font-extrabold font-['Inter']">
                  {kpiData?.totalDeliveries || 0}
                </div>
              </div>
              <div className="flex-1 self-stretch p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                    On-Time Deliveries
                  </div>
                </div>
                <div className="justify-start text-slate-800 text-3xl font-extrabold font-['Inter']">
                  {kpiData?.onTimeDeliveryCount || 0}
                </div>
              </div>
              <div className="flex-1 self-stretch p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                    Late Deliveries
                  </div>
                </div>
                <div className="justify-start text-red-600 text-3xl font-extrabold font-['Inter']">
                  {kpiData?.lateDeliveryCount || 0}
                </div>
              </div>
              <div className="flex-1 self-stretch p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                    Total Pickups
                  </div>
                </div>
                <div className="justify-start text-slate-800 text-3xl font-extrabold font-['Inter']">
                  {kpiData?.totalPickup || 0}
                </div>
              </div>
              <div className="flex-1 self-stretch p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                    On-Time Pickups
                  </div>
                </div>
                <div className="justify-start text-slate-800 text-3xl font-extrabold font-['Inter']">
                  {kpiData?.onTimePickupCount || 0}
                </div>
              </div>
              <div className="flex-1 self-stretch p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                    Late Pickups
                  </div>
                </div>
                <div className="justify-start text-red-600 text-3xl font-extrabold font-['Inter']">
                  {kpiData?.latePickupCount || 0}
                </div>
              </div>
              <div className="flex-1 self-stretch p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                    Customer Review Count
                  </div>
                </div>
                <div className="justify-start text-slate-800 text-3xl font-extrabold font-['Inter']">
                  {kpiData?.customerReviewCount || 0}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-4">
              {kpiData?.executiveKpi &&
                kpiData?.executiveKpi.map((data, index) => (
                  <div className="self-stretch w-full p-5 bg-white rounded-xl shadow-[0px_2px_8px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-4">
                    <div className="self-stretch inline-flex justify-between items-center">
                      <div className="size- flex justify-start items-center gap-3">
                        <Person3Icon />
                        <div className="size- inline-flex flex-col justify-start items-start gap-0.5">
                          <div className="justify-start text-slate-800 text-base font-bold font-['Inter']">
                            {data?.name || "N/A"}
                          </div>
                          {/* <div className="justify-start text-slate-500 text-xs font-normal font-['Inter']">
                      Delivery Executive
                    </div> */}
                        </div>
                      </div>
                      {/* <div className="size- px-2.5 py-1 bg-emerald-50 rounded-lg outline outline-1 outline-offset-[-1px] outline-emerald-100 flex justify-start items-start">
                  <div className="justify-start text-emerald-800 text-xs font-semibold font-['Inter']">
                    Excellent
                  </div>
                </div> */}
                    </div>
                    <div className="self-stretch w-full flex flex-col justify-start items-start gap-3">
                      <div className="self-stretch inline-flex justify-start items-start gap-3">
                        <div className="flex-1 p-3 bg-slate-50 rounded-lg inline-flex flex-col justify-start items-start gap-1">
                          <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                            On-Time Deliveries
                          </div>
                          <div className="justify-start text-green-600 text-base font-bold font-['Inter']">
                            {data?.onTimeDeliveryCount || 0}
                          </div>
                        </div>
                        <div className="flex-1 p-3 bg-slate-50 rounded-lg inline-flex flex-col justify-start items-start gap-1">
                          <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                            Late Deliveries
                          </div>
                          <div className="justify-start text-red-600 text-base font-bold font-['Inter']">
                            {data?.lateDeliveryCount || 0}
                          </div>
                        </div>
                      </div>
                      <div className="self-stretch inline-flex justify-start items-start gap-3">
                        <div className="flex-1 p-3 bg-slate-50 rounded-lg inline-flex flex-col justify-start items-start gap-1">
                          <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                            On-Time Pickups
                          </div>
                          <div className="justify-start text-green-600 text-base font-bold font-['Inter']">
                            {data?.onTimePickupCount || 0}
                          </div>
                        </div>
                        <div className="flex-1 p-3 bg-slate-50 rounded-lg inline-flex flex-col justify-start items-start gap-1">
                          <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                            Late Pickups
                          </div>
                          <div className="justify-start text-red-600 text-base font-bold font-['Inter']">
                            {data?.latePickupCount || 0}
                          </div>
                        </div>
                      </div>
                      <div className="self-stretch inline-flex justify-start items-start gap-3">
                        <div className="flex-1 p-3 bg-slate-50 rounded-lg inline-flex flex-col justify-start items-start gap-1">
                          <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                            Review Collected
                          </div>
                          <div className="justify-start text-green-600 text-base font-bold font-['Inter']">
                            {data?.myReviewCollectedCount || 0}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="self-stretch pt-3 border-t border-slate-200 inline-flex justify-start items-start gap-4">
                <div className="flex-1 flex justify-start items-center gap-1.5">
                  <div className="size-4 relative overflow-hidden">
                    <div className="w-3.5 h-3 left-[1.33px] top-[1.33px] absolute outline outline-2 outline-offset-[-1px] outline-amber-500" />
                  </div>
                  <div className="justify-start text-slate-800 text-xs font-semibold font-['Inter']">
                    4.9
                  </div>
                </div>
                <div className="flex-1 flex justify-start items-center gap-1.5">
                  <div className="size-4 relative overflow-hidden">
                    <div className="w-3.5 h-2 left-[1.33px] top-[4px] absolute outline outline-2 outline-offset-[-1px] outline-slate-500" />
                  </div>
                  <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                    12
                  </div>
                </div>
                <div className="flex-1 flex justify-start items-center gap-1.5">
                  <div className="size-4 relative overflow-hidden">
                    <div className="w-3.5 h-3 left-[1.33px] top-[2px] absolute outline outline-2 outline-offset-[-1px] outline-slate-500" />
                  </div>
                  <div className="justify-start text-slate-500 text-xs font-medium font-['Inter']">
                    45
                  </div>
                </div>
              </div> */}
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Kpidashboard;
